import { useLocation, useRouteMatch } from 'react-router-dom'
import React, { useState } from 'react'

interface CoachRouteData {
	value: number
	label: string
	name: string
	to: string
	ariaLabel: string,
	// disabled?: boolean | null
}

export const useCoachOverviewRoute = (): [
	number,
	Array<CoachRouteData>,
	(event: React.SyntheticEvent, newValue: number) => void
] => {
	const { url } = useRouteMatch()
	const location = useLocation()

	const coachRouteData: Array<CoachRouteData> = [
		{
			value: 0,
			label: 'General',
			name: 'general',
			to: url,
			ariaLabel: 'Link to coach general',
		},

		{
			value: 1,
			label: 'Assigned patients',
			name: 'assigned-patients',
			to: `${url}/assigned-patients`,
			ariaLabel: 'Link to coach general',
		},

		{
			value: 2,
			label: 'History log',
			name: 'history-log',
			to: `${url}/history-log`,
			ariaLabel: 'Link to coach history log',
		},

	]

	const [currentTabValue, setTabValue] = useState<number>((): number => {
		const curLocData = coachRouteData.find(route =>
			location.pathname.includes(route.name)
		)

		return curLocData?.value || 0
	})

	const handleChangeRoute = (
		event: React.SyntheticEvent,
		newValue: number
	): void => {
		setTabValue(newValue)
	}

	return [currentTabValue, coachRouteData, handleChangeRoute]
}
